import ApiService from "@/services/api";
import { getError } from "@/util";

export const state = {
  passTypes: []
};
export const mutations = {
  SET_PASS_TYPES(state, passTypes) {
    state.passTypes = passTypes;
  }
};
export const actions = {
  getPassTypes({ commit }) {
    return ApiService.passTypes
      .getTypes()
      .then(response => {
        commit("SET_PASS_TYPES", response.data.data.passes);
      })
      .catch(error => {
        // couldn't load passes
      });
  }
};
export const getters = {
  passTypes: state => {
    return state.passTypes;
  }
};
